import { ValidationUtility } from "../validation-utility";
import { IValidatorType } from "../validator-interface";

// ── Provision OneSignal App ──────────────────────────────────────────────────

export interface IProvisionOneSignalAppReq {
	communityId: string;
	force?: boolean;
}

export const VProvisionOneSignalApp: IValidatorType<IProvisionOneSignalAppReq> = {
	communityId: {
		function: (v: string) => ValidationUtility.validateStringFields(v, 1, 64),
		params: [],
		required: true,
	},
	force: {
		function: (v: any) =>
			v === undefined || v === null
				? undefined
				: typeof v === "boolean"
					? v
					: undefined,
		params: [],
		required: false,
	},
};

export interface IProvisionOneSignalAppRes {
	appId: string;
	status: number;
}

// ── Public OneSignal credentials (no secrets) ────────────────────────────────

export interface IOneSignalPublicInfo {
	available: boolean;
	appId?: string;
	status?: number;
}
